import {
  MODULE_METADATA_ERROR,
  MODULE_METADATA_REQUEST,
  MODULE_METADATA_SUCCESS,
  ALL_MODULES_METADATA_ERROR,
  ALL_MODULES_METADATA_SUCCESS,
  ALL_MODULES_METADATA_REQUEST,
  ALL_MODULES_UPDATE_ORDER,
} from "../../actionTypes";
import { ModuleMetadataSTORE, ModulesActionTypes } from "../../types";

import byIdReducer from "./module/byId";
import allModulesReducer from "./allModules/allModules";

const initialState: ModuleMetadataSTORE = {
  byId: {},
  isFetching: false,
};

const reducer = (
  state = initialState,
  action: ModulesActionTypes
): ModuleMetadataSTORE => {
  switch (action.type) {
    case ALL_MODULES_METADATA_ERROR:
    case ALL_MODULES_METADATA_SUCCESS:
    case ALL_MODULES_METADATA_REQUEST:
    case ALL_MODULES_UPDATE_ORDER:
      return allModulesReducer(state, action);

    case MODULE_METADATA_ERROR:
    case MODULE_METADATA_REQUEST:
    case MODULE_METADATA_SUCCESS:
      return {
        ...state,
        byId: byIdReducer(state.byId, action),
      };

    default:
      return state;
  }
};

export default reducer;
